export default "__VITE_ASSET__BQjFms$a__"